export enum TrackingScreenNamesEnum {
  account_sign_in = 'account_sign_in',
  account_sign_up = 'account_sign_up',
  change_email_cancel = 'change_email_cancel',
  change_email_failed = 'change_email_failed',
  change_email_success = 'change_email_success',
  choose_existing_account = 'choose_existing_account',
  forgot_password = 'forgot_password',
  set_password = 'set_password',
  set_password_failed = 'set_password_failed',
  set_password_success = 'set_password_success',
  unusual_login_verification = 'unusual_login_verification',
  unusual_login_verification_result = 'unusual_login_verification_result',
  verify_email_success = 'email_verification_success',
  verify_email_failure = 'email_verification_failed',
}

export enum TrackingObjectNamesEnum {
  account = 'account',
}
